import React, { useState } from 'react';
import { Container } from './styles';
import { ECodeType } from '../../../../../../store/ducks/user/types';
import { Chips } from '@gerdau/hefesto-mais-web/Chips';

interface ISearchItemRadioSelectProps {
  disabled: boolean;
  codeType: ECodeType;
  setCodeType(codeType: ECodeType): void;
}
const SearchItemRadioSelect: React.FC<ISearchItemRadioSelectProps> = ({
  disabled,
  codeType,
  setCodeType
}) => {
  const [selectedChips, setSelectedChips] = useState<string[]>([
    codeType ?? ECodeType.SKU
  ]);
  const optionsChoice = [
    { id: ECodeType.SKU, label: 'Código Gerdau de material' },
    { id: ECodeType.CLIENT_SKU, label: 'Meu código interno de material' }
  ];

  return (
    <Container>
      <span>Qual código de material você utiliza?</span>

      <Chips
        chips={optionsChoice}
        disabled={disabled}
        type="choice"
        selectedChipIds={selectedChips}
        handleSelect={(e) => {
          if (e.length) {
            const [option] = e;
            const selectedOptionCodeType: ECodeType =
              ECodeType[option as ECodeType];
            setCodeType(selectedOptionCodeType);
            setSelectedChips(e);
            return;
          }
          setSelectedChips([codeType]);
        }}
      />
    </Container>
  );
};

export default SearchItemRadioSelect;
